export default __webpack_public_path__ + "static/media/ProximaNova-SemiboldItalic.c9b17812.otf";